import { loadingAppsTable } from '@/containers/applications/table'
import { convocatoriasStateActions } from '@/state/actions'
import { ConvocatoriasState } from '@/state/convocatorias'
import { OfflineState } from '@/state/offline-management'
import { Select } from 'antd'

export default function ConvocatoriaCityFilter() {
  return (
    <Select
      className='convocatoria-city-filter'
      allowClear
      showSearch
      placeholder='Seleccionar municipio'
      options={ConvocatoriasState.cities.value}
      onChange={convocatoriasStateActions.setCurrentCity}
      filterOption={(input, option: any) =>
        option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      value={ConvocatoriasState.currentCity.value}
      disabled={OfflineState.isSynchronizing.value || loadingAppsTable.value}
    />
  )
}
